import { render, staticRenderFns } from "./SideDrawer.vue?vue&type=template&id=b7c50314&scoped=true&"
import script from "./SideDrawer.vue?vue&type=script&lang=ts&"
export * from "./SideDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./SideDrawer.vue?vue&type=style&index=0&id=b7c50314&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c50314",
  null
  
)

export default component.exports